import { render } from "./Client-articles.vue?vue&type=template&id=6fe56c28&scoped=true"
import script from "./Client-articles.vue?vue&type=script&lang=js"
export * from "./Client-articles.vue?vue&type=script&lang=js"

import "./Client-articles.vue?vue&type=style&index=0&id=6fe56c28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe56c28"]])

export default __exports__